// packages/web-ui/src/panels/views/PortNode.tsx
//
// W4-S1 — Standalone port-shape node. Renders when a port appears as a
// top-level node (`type: 'port'`) in `ReactFlowLayoutJson`. The handle ids
// follow the same `${name}.t` / `${name}.s` convention as the inline ports
// inside `<PartNode>` so cross-references continue to resolve.

import type { JSX } from 'react';
import { Handle, Position, type NodeProps } from '@xyflow/react';
import type { PortNodeData } from './layout-builder.js';

export function PortNode({ data, id }: NodeProps): JSX.Element {
  const portData = (data ?? {}) as PortNodeData;
  const portName = portData.name ?? portData.label ?? id;

  return (
    <div
      data-kind="port"
      data-port-name={portName}
      style={{
        position: 'relative',
        width: 80,
        height: 28,
        background: 'var(--tessa-bg)',
        border: '1.5px solid var(--tessa-border)',
        borderRadius: 4,
        color: 'var(--tessa-fg)',
        fontSize: 11,
        textAlign: 'center',
        lineHeight: '28px',
      }}
    >
      <span>{portName}</span>
      <Handle
        type="target"
        position={Position.Left}
        id={`${portName}.t`}
        style={{
          width: 9,
          height: 9,
          background: 'var(--tessa-bg)',
          border: '1.2px solid var(--tessa-border)',
          borderRadius: 0,
        }}
      />
      <Handle
        type="source"
        position={Position.Right}
        id={`${portName}.s`}
        style={{
          width: 9,
          height: 9,
          background: 'var(--tessa-bg)',
          border: '1.2px solid var(--tessa-border)',
          borderRadius: 0,
        }}
      />
    </div>
  );
}

export default PortNode;
